import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Container,
    Header,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import {
    Button,
    Popup } from 'semantic-ui-react'
import { api } from '../../../services/api';
import moment from 'moment';

import Navbarr from '../../../components/Navbar';
import CardTable from '../../../components/CardTable';

import './styles.css';

export default function CompetitorsList({ sidebar: Sidebar}) {
    const history = useHistory();
    const [prodStates, setProdStates] = useState({
        isLoadingData: true,
        lasUpdate: "",
        reloadControl: false,
    });

    const [tableData, setTableData] = useState({
        columns: [
            {
                label: 'Identificador',
                field: 'id',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Nome',
                field: 'nome',
                sort: 'asc',
                width: 400
            },
            {
                label: 'Ações',
                field: 'acao',
                sort: 'asc',
                width: 100
            }
        ],
        rows: [],
    });

    const updateComptData = () => {
        setProdStates( prevState => ({
            ...prevState,
            reloadControl: !prevState['reloadControl'],
        }));
    }

    useEffect(() => {
        const goToComptEditScreen = (e, prod, index) => {
            e.preventDefault();
            history.push(`/competitors/${prod['id']}`, {productId: prod['id']});
        }

        const changeComptForTable = (prod, index) => {
            prod['acao'] = <Popup content='Visualizar'
                trigger={
                    <Button basic size='mini' icon='eye' onClick={(e) => goToComptEditScreen(e, prod, index)} />
                } />
            return prod;
        }

        async function fetchProds() {
            setProdStates( prevState => ({
                ...prevState,
                isLoadingData: true
            }));
            try {
                let data = await api.getCompProducts();
                data.forEach((element, index) => { changeComptForTable(element, index)});

                setTableData( prevState => ({
                  ...prevState,
                  rows: data
                }));

                setProdStates( prevState => ({
                    ...prevState,
                    isLoadingData: false,
                    lastUpdate: moment().format('LT')
                }));
            } catch (err) {
              console.error("Falha ao obter produtos: ", err);
            }
        }

        fetchProds();
    },[prodStates.reloadControl, history]);

    return (
        <Container>
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"comptlist"}></Sidebar>
            </Side>
            <Container>
                <Header>
                    <Navbarr></Navbarr>
                </Header>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px' }}>
                    <CardTable
                        type={'comptProd'}
                        data={tableData}
                        tableTitle={"Competidores"}
                        elementsName={"produtos"}
                        isLoadingData={prodStates['isLoadingData']}
                        lastUpdate={prodStates['lastUpdate']}
                        updateData={updateComptData}
                    />
                </Content>
                <Footer></Footer>
            </Container>
        </Container>
    )
}
